import React, { useEffect, useState } from 'react';
import BookBanner from './BookBanner';
import WorkBookList from './WorkBookList';
import BookRelatedBooks from './BookRelatedBooks';
import BookDetailSpecs from './BookDetailSpecs';
import { Link, useParams } from 'react-router-dom';
import YouTube from 'react-youtube';
import { useSelector } from 'react-redux';
import BookCard from '../../components/BookCard';
// import { scrollToElement } from '../../../lib/userFunctions';

const BookDescription = ()=>{
    const { school } = useParams();
    const detailBook = useSelector(state => state.detailBook);
    
    // useEffect(() => {
    //     scrollToElement('lnb');
    // }, [detailBook]);

    if( null===detailBook.book ) return <div></div>;

    
    return (
        <div className="inner book_intro">
            <BookDetailSpecs book={detailBook.book} />

            <BookData book={detailBook.book} cardList={detailBook.cardList} workBooks={detailBook.workBooks} />
            
            <BookBannerList bannerList={detailBook.bannerList} />
            
            <BookRelatedBooks bookList={detailBook.relatedBooks} title={ <span>연관 도서</span> } />
            <BookRelatedBooks bookList={detailBook.relatedPublisherBooks} title={
                <Link to={`/${school}/book?search_keyword=${detailBook.book.publisher}`}>
                    <span>{detailBook.book.publisher}</span>의 다른 도서
                </Link>
            } />
        </div>
    );
};
export default BookDescription;

const BookData = ({book, workBooks=null, cardList=null}) => {
    const hasYoutube = (null!==book.youtube_code && ''!==book.youtube_code);
    const hasWorkbook = (null!==workBooks && workBooks.length>0);
    const hasCard = (null!==cardList && cardList.length>0);
    const [tab, setTab] = useState('');
    
    useEffect(() => {
      if(hasWorkbook){
        setTab('workbook');
      }else if(hasYoutube){
        setTab('youtube');
      }else if(hasCard){
        setTab('card');
      }
    }, [hasYoutube, hasWorkbook, hasCard]);
    
    if( !(hasYoutube||hasWorkbook||hasCard) )return null;
    
    return (
        <div className="section">
            <div className="category_title book_data">독서자료</div>
            <div className="contents">
                <ul className="tabs">
                    {hasWorkbook && <li className={tab==='workbook'?'on':''} onClick={()=>setTab('workbook')}>독서활동지</li> }
                    {hasCard && <li className={tab==='card'?'on':''} onClick={()=>setTab('card')}>독서카드</li> }
                    {hasYoutube && <li className={tab==='youtube'?'on':''} onClick={()=>setTab('youtube')}>책 소개 영상</li>}
                </ul>
                {hasYoutube && tab==='youtube' &&
                    <div className="intro_video">
                        <div className="title_wrap">
                            <h4><span></span> 독서영상 <span></span></h4>
                        </div>
                        <YouTube className="youtube" videoId={book.youtube_code}  onReady={(event)=>{event.target.pauseVideo();}} />
                    </div>
                }

                {hasWorkbook && tab==='workbook' &&
                    <WorkBookList book={book} workBooks={workBooks} />
                }

                { hasCard && tab==='card' && 
                    <div data-aos="fade-right" data-aos-duration="1000" className="text-center book_card">
                        <div className="title_wrap">
                            <h4><span></span> 독서카드 <span></span></h4>
                        </div>
                        <BookCard list={cardList.map(item=>item.image)} loop={true} />
                    </div>
                }
            </div>
        </div>
    )
};

const BookBannerList = ({bannerList})=>{
    if( null===bannerList )return null;
    if( bannerList.length<=0)return null;
    let list = bannerList.map( (banner, key)=>{
        return <BookBanner banner={banner} key={key} />
    });
    return (
        <div className="section">
            <div className="category_title">독서배너</div>
            <div className="banner contents">
            {list}
            </div>
        </div>
    )
}//end renderBanner